import { typeCreatorV2 } from '../../../redux/utils/common';

//  [REDUCER][TYPE]
export const SET_VAT_RETURN_RECEIVED_LIST: string = typeCreatorV2(
  'VatReturnsReceivedListReducer',
  'SetVatReturnsReceivedList'
);

export const SET_UNREAD_NOTIFICATION_COUNT: string = typeCreatorV2(
  'VatReturnsReceivedListReducer',
  'SetUnreadNotificationCount'
);

export const SET_MEMBER_STATE_EXCLUDE_CYPRUS: string = typeCreatorV2(
  'VatReturnsReceivedListReducer',
  'SetMemberStateCountriesExcludeCyprus'
);

export const SET_PAYMENT_RECEIVED_DETAIL_LIST: string = typeCreatorV2(
  'PaymentReceivedDetailListReducer',
  'SetPaymentReceivedDetailList'
);
